export default __webpack_public_path__ + "static/media/effect-1024.052af45a.mp3";